import React from 'react';
import { useNavigate } from 'react-router-dom';

function TeamCard({ teamMembers = [] }) {
  const navigate = useNavigate();

  const displayedMembers = teamMembers.slice(0, 7);

  const goToTeamDirectory = () => {
    navigate('/therapist/team');
  };

  return (
    <div style={teamCardStyle} onClick={goToTeamDirectory}>
      <div style={cardHeaderStyle}>
        <div style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Your Team</div>
      </div>

      <div style={cardBodyStyle}>
        {displayedMembers.length > 0 ? (
          <>
            <div style={teamCircleContainerStyle}>
              {displayedMembers.map((member, index) => {
                const angle = (index * (2 * Math.PI / displayedMembers.length)) - Math.PI / 2;
                const radius = 70;
                const x = radius * Math.cos(angle);
                const y = radius * Math.sin(angle);

                return (
                  <div
                    key={member.therapist_id || index}
                    style={{
                      ...memberPhotoContainerStyle,
                      transform: `translate(${x}px, ${y}px)`
                    }}
                  >
                    {member.photo_url ? (
                      <img
                        src={member.photo_url}
                        alt={`${member.first_name} ${member.last_name}`}
                        style={memberPhotoStyle}
                      />
                    ) : (
                      <div style={{
                        ...memberPhotoStyle,
                        backgroundColor: '#e0e0e0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.8rem',
                        color: '#666'
                      }}>
                        {member.first_name ? member.first_name.charAt(0) : ''}
                        {member.last_name ? member.last_name.charAt(0) : ''}
                      </div>
                    )}
                  </div>
                );
              })}

              {teamMembers.length > 7 && (
                <div style={extraMembersStyle}>
                  +{teamMembers.length - 7}
                </div>
              )}
            </div>

            <p style={cardSubtext}>
              {teamMembers.length} team members
            </p>
          </>
        ) : (
          <div style={emptyStateStyle}>
            <p>No team members found</p>
          </div>
        )}

        <p style={viewTeamTextStyle}>
          Click to view team directory
        </p>
      </div>
    </div>
  );
}

const teamCardStyle = {
  background: '#fff',
  borderRadius: 12,
  boxShadow: '0 1px 8px rgba(0,0,0,0.09)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  height: '100%',
};

const cardHeaderStyle = {
  background: '#1D2C5F',
  padding: '14px 20px',
};

const cardBodyStyle = {
  padding: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flex: 1,
};

const teamCircleContainerStyle = {
  position: 'relative',
  width: '180px',
  height: '180px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '1rem'
};

const memberPhotoContainerStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(0, 0)',
  transition: 'transform 0.3s ease'
};

const memberPhotoStyle = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  objectFit: 'cover',
  border: '2px solid #1D2C5F',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
};

const extraMembersStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: '#1D2C5F',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  fontSize: '0.9rem',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
};

const cardSubtext = {
  margin: '0 0 0.5rem 0',
  fontSize: '1rem',
  color: '#666',
  textAlign: 'center'
};

const emptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem 0',
  color: '#999',
  flex: 1
};

const viewTeamTextStyle = {
  fontSize: '0.9rem',
  color: '#878DA1',
  fontWeight: 600,
  margin: 'auto 0 0 0',
  textAlign: 'center',
  padding: '0.5rem 0'
};

export default TeamCard;
